import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "LiquidityPlan" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
